import { SerializedComponent } from "../../components/SerializedApp";
import { ArrayScreenFormat, TableGlideType } from "../description";
import {
    FallbackInitialsSummaryArrayContentDescription,
    FallbackInitialsSummaryArrayScreenDescription,
    FallbackInitialsSummaryArrayScreenHandler,
    isolateFallbackInitialsSummaryArrayContentDescription,
} from "./summary-array-screen";
import { ComponentBuilder } from "../components";
import { getFeatureSetting } from "../../feature-settings";
import { FixedArrayContent } from "./array-content";
import { makeEnumProperty, makeSwitchProperty } from "../components/property-utils";
import { ImageAspectRatio, TilesPadding, Corners, TextPosition, OverlayTextAlignment } from "../components/image-types";
import { TextSize } from "../components/text-types";
import { TilesArrayContentDescription } from "./tiles-array-screen";

export type ColumnContentDescription = FallbackInitialsSummaryArrayContentDescription;
type ColumnScreenDescription = FallbackInitialsSummaryArrayScreenDescription;

export class ColumnScreenHandler extends FallbackInitialsSummaryArrayScreenHandler<
    ColumnContentDescription,
    ColumnScreenDescription
> {
    protected readonly supportsNonURLImages = true;
    protected readonly supportsEmojiImages = false;
    protected readonly supportsTruncateList = false;

    constructor() {
        super(ArrayScreenFormat.Columns, "Columns", "columns", true);
    }

    public get isLegacy(): boolean {
        return !getFeatureSetting("preTileScreens");
    }

    protected contentWithFallbackInitials(
        { b }: ComponentBuilder,
        _desc: ColumnScreenDescription,
        _table: TableGlideType,
        arrayData: SerializedComponent,
        title: SerializedComponent,
        subtitle: SerializedComponent | undefined,
        image: SerializedComponent | undefined,
        initials: SerializedComponent | undefined,
        onTap: SerializedComponent | undefined,
        onDropImage: SerializedComponent | undefined
    ): SerializedComponent {
        return b.ui("ColumnList", {
            list: arrayData,
            item: b.ui("ColumnItem", { title, subtitle, image, fallbackInitials: initials, onTap, onDropImage }),
        });
    }

    public fixContentDescription(columnContent: ColumnContentDescription): FixedArrayContent | undefined {
        return {
            properties: {
                ...isolateFallbackInitialsSummaryArrayContentDescription(columnContent),
                size: makeEnumProperty(ImageAspectRatio.Square),
                numColumns: makeEnumProperty(2),
                padding: makeEnumProperty(TilesPadding.Loose),
                isHorizontal: makeEnumProperty(false),
                allowWrapping: makeSwitchProperty(false),
                corners: makeEnumProperty(Corners.Rounded),
                textPosition: makeEnumProperty(TextPosition.Below),
                overlayTextAlignment: makeEnumProperty(OverlayTextAlignment.Center),
                textSize: makeEnumProperty(TextSize.Medium),
                allCaps: makeSwitchProperty(false),
            } as TilesArrayContentDescription,
            format: ArrayScreenFormat.Tiles,
        };
    }
}
